module.exports = __webpack_public_path__ + "static/media/citysightseeing.1c57cf6f.jpg";